import { useEffect } from 'react';

import useFluxibleAction from 'js/lib/fluxibleHooks/useFluxibleAction';
import useFluxibleStore from 'js/lib/fluxibleHooks/useFluxibleStore';
import user from 'js/lib/user';

import { loadVerificationDisplay } from 'bundles/in-course-stores/actions/VerificationActions';
import CourseStore from 'bundles/in-course-stores/stores/CourseStore';
import S12nStore from 'bundles/in-course-stores/stores/S12nStore';

export const useLoadVerificationDisplay = () => {
  const { course, courseLoading } = useFluxibleStore(CourseStore, (store) => ({
    course: store.getMetadata(),
    courseLoading: !store.hasLoaded(),
  }));

  const { s12n, s12nLoading } = useFluxibleStore(S12nStore, (store) => ({
    s12n: store.getS12n(),
    s12nLoading: !store.hasLoaded(),
  }));

  const executeAction = useFluxibleAction();

  const loading = courseLoading || s12nLoading;

  useEffect(() => {
    if (!loading && course) {
      const userId = user.get().id.toString();
      const authenticated = user.isAuthenticatedUser();

      const s12nId = s12n?.getId();
      const isCourseVerificationEnabled = course.isVerificationEnabled();

      executeAction(loadVerificationDisplay, {
        authenticated,
        userId,
        courseId: course.id,
        isCourseVerificationEnabled,
        s12nId,
      });
    }
  }, [loading, course, s12n, executeAction]);
};
